document.addEventListener("DOMContentLoaded", () => {
  const SPEED_PX_PER_SEC = 60;

  /* ---------- STICKY CONTAINER ---------- */

  const bar = document.querySelector(".announcement-bar");
  if (bar && !bar.dataset.stickyInit) {
    bar.dataset.stickyInit = "true";

    const section = bar.parentElement; // wrapper that also holds background
    const height = section.offsetHeight;

    const spacer = document.createElement("div");
    spacer.style.height = height + "px";
    section.parentNode.insertBefore(spacer, section);

    section.style.position = "fixed";
    section.style.top = "0";
    section.style.left = "0";
    section.style.width = "100%";
    section.style.zIndex = "9999";
  }

  /* ---------- MARQUEE SCROLL ---------- */

  document.querySelectorAll(".announcement-bar__slides").forEach(slides => {

    if (slides.dataset.marqueeInit) return;
    slides.dataset.marqueeInit = "true";

    const container = slides.parentElement;

    while (slides.scrollWidth < container.offsetWidth * 2) {
      slides.innerHTML += slides.innerHTML;
    }

    let pos = container.offsetWidth;
    let lastTime = null;
    let trackWidth = slides.scrollWidth / 2;

    slides.style.transform = `translateX(${pos}px)`;
    slides.style.visibility = "visible";

    function animate(ts) {
      if (!lastTime) lastTime = ts;

      const delta = ts - lastTime;
      lastTime = ts;

      pos -= (SPEED_PX_PER_SEC * delta) / 1000;

      if (pos <= -trackWidth) {
        pos = container.offsetWidth;
      }

      slides.style.transform = `translateX(${pos}px)`;
      requestAnimationFrame(animate);
    }

    window.addEventListener("resize", () => {
      trackWidth = slides.scrollWidth / 2;
      pos = container.offsetWidth;
      slides.style.transform = `translateX(${pos}px)`;
    });

    requestAnimationFrame(animate);
  });
});